import React from 'react';
import SEO from '../components/SEO';
import UtilityPageLayout from '../components/UtilityPageLayout';
import UtilitySection from '../components/UtilitySection';
import { siteInfo } from '../data/siteInfo';

const Terms = () => {
  const companyName = siteInfo.companyName;
  const brandName = siteInfo.brandName;
  const { companyNumber, tpoSchemeName, tpoMembership, complaintsEmail } = siteInfo.legal;
  const complaintsMail = `mailto:${complaintsEmail}`;

  return (
    <>
      <SEO
        title={`Terms & Conditions | ${companyName}`}
        description={`Terms and conditions for ${companyName} property investment and management services.`}
      />

      <UtilityPageLayout eyebrow="Legal" title="Terms & Conditions" meta={`Last updated: ${siteInfo.legal.legalUpdated}`}>
        <UtilitySection title="1. Definitions">
          <p>
            &quot;{brandName}&quot;, &quot;we&quot;, &quot;us&quot; or &quot;our&quot; refers to {companyName} (Company No. {companyNumber}), registered in England and Wales.
          </p>
          <p>&quot;Client&quot;, &quot;you&quot; or &quot;your&quot; refers to the individual or organisation engaging our services.</p>
          <p>&quot;Property&quot; means any residential or commercial real estate listed with or referred to {brandName}.</p>
        </UtilitySection>

        <UtilitySection title="2. Scope of Services">
          <p>{companyName} provides property services including:</p>
          <ul>
            <li>Property investment partnerships and sourcing advice</li>
            <li>Property acquisition and sales across the UK</li>
            <li>Ownership and management of our rental property portfolio</li>
            <li>Refurbishment projects and income-generating asset sourcing</li>
          </ul>
          <p>
            {companyName} is a member of {tpoSchemeName} ({tpoMembership}) and abides by the relevant code of practice.
          </p>
        </UtilitySection>

        <UtilitySection title="3. Property Listings">
          <p>
            All property details are provided in good faith based on information supplied by the vendor or landlord. Measurements are approximate and have not been verified. Buyers and tenants must satisfy themselves as to the accuracy of all particulars before making an offer or signing a lease.
          </p>
          <p>{brandName} reserves the right to withdraw or amend any listing without notice.</p>
        </UtilitySection>

        <UtilitySection title="4. Fees and Transactions">
          <p>
            Any fees, profit shares, or sourcing charges for investment partnerships, sourcing projects, and acquisitions will be agreed upon in writing via separate partnership agreements prior to commencing any transactions.
          </p>
          <p>
            Rental fees and rental agreements for properties in our portfolio will be outlined in standard Tenancy Agreements or Commercial Lease Agreements.
          </p>
        </UtilitySection>

        <UtilitySection title="5. Client Obligations">
          <p>You agree to:</p>
          <ul>
            <li>Provide accurate information about your property and personal circumstances</li>
            <li>Comply with all applicable laws, including anti-money laundering regulations</li>
            <li>Provide valid identification documents as required by the Money Laundering Regulations 2017</li>
            <li>Notify us immediately of any material change in circumstances</li>
          </ul>
        </UtilitySection>

        <UtilitySection title="6. Liability">
          <p>
            {companyName}&apos;s liability to you is limited to the fees paid to us in the twelve months preceding any claim. We are not liable for any indirect, consequential or economic loss arising from our services.
          </p>
          <p>Nothing in these terms excludes liability for death or personal injury caused by our negligence, or any liability that cannot be excluded by applicable law.</p>
        </UtilitySection>

        <UtilitySection title="7. Complaints">
          <p>
            We are committed to providing excellent service. If you have a complaint, please contact us by email at{' '}
            <a href={complaintsMail}>{complaintsEmail}</a>.
          </p>
          <p>
            We will acknowledge your complaint promptly and aim to resolve it fairly. If your complaint cannot be resolved internally, you may refer it to {tpoSchemeName}.
          </p>
        </UtilitySection>

        <UtilitySection title="8. Governing Law">
          <p>These terms are governed by and construed in accordance with the laws of England and Wales. Any disputes arising shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
        </UtilitySection>

        <UtilitySection title="9. Amendments">
          <p>We may amend these terms from time to time. The current version will always be published on this website.</p>
        </UtilitySection>
      </UtilityPageLayout>
    </>
  );
};

export default Terms;
